/**
 * CompressionUtils.ts
 * Utilitaires de compression pour les projets JSON
 */
import { logger } from './ProfessionalLogger';

/**
 * Compresse une chaîne JSON en utilisant LZ-String (légère, pas de dépendance externe)
 * Fallback vers btoa si LZ-String n'est pas disponible
 */
export function compressJSON(jsonString: string): string {
  try {
    // Utiliser LZ-String si disponible (plus efficace)
    if (window.LZString) {
      return window.LZString.compressToUTF16(jsonString);
    }
    // Fallback: compression simple avec btoa (base64)
    // Note: btoa n'est pas vraiment une compression, mais réduit légèrement la taille
    return btoa(unescape(encodeURIComponent(jsonString)));
  } catch (error) {
    logger.error('Erreur lors de la compression JSON:', error);
    return jsonString; // Retourner non compressé en cas d'erreur
  }
}

/**
 * Décompresse une chaîne JSON compressée
 */
export function decompressJSON(compressedString: string): string {
  try {
    // Utiliser LZ-String si disponible
    if (window.LZString) {
      return window.LZString.decompressFromUTF16(compressedString);
    }
    // Fallback: décompression base64
    return decodeURIComponent(escape(atob(compressedString)));
  } catch (error) {
    logger.error('Erreur lors de la décompression JSON:', error);
    return compressedString; // Retourner tel quel en cas d'erreur
  }
}

/**
 * Calcule le ratio de compression
 */
export function getCompressionRatio(original: string, compressed: string): number {
  if (original.length === 0) return 0;
  return Math.round((1 - compressed.length / original.length) * 100);
}
